<template>
  <listview :vm="listVm" hide-year-filter />
</template>

<script>
  import Listview from '@/components/base/Listview';
  import ListVm from '@/components/base/ListVm';
  import Format from '@/format';
  import Router from '@/router';

////////////////////////
///////////////////////////////
///////////
  const sortBy = 'Document_No'
////////////

  const _comp = {
    name: 'OpenPosten',
    data: () => ({
      listVm: null
    }),
    created() {
      this.listVm = new ListVm(
        'Open posten',
        sortBy,
        (ctx) => `/odata/CustomerLedgerEntry?$filter=Open eq true`,
        ['Posting_Date', 'Due_Date'],
        (srch, items) => items.filter(i => `${i.Document_No}${i.Customer_No}${i.wCustomerName}${i.External_Document_No}`.toLowerCase().indexOf(srch.toLowerCase()) != -1),
        (item) => {
          if (item.Document_Type === 'Creditnota') {
            Router.push('/CreditNota/' + item.Document_No);
          } else if (item.Document_Type === 'Factuur') {
            Router.push('/Factuur/' + item.Document_No);
          }
        },
        [
          { name: 'Document nr.', sort: 'Document_No', select: i => i.Document_No },
          { name: 'Klant nr.', sort: 'Customer_No', select: i => i.Customer_No },
          { name: 'Klant', sort: 'wCustomerName', select: i => i.wCustomerName },
          { name: 'Boekingsdatum', sort: 'Posting_Date', select: i => i.Posting_Date ? Format.date(i.Posting_Date) : '' },
/////////////////////////////////
          { name: 'Vervaldatum', sort: 'Due_Date', select: i => i.Due_Date ? Format.date(i.Due_Date) : '' },
////////////////////
          { name: 'Bedrag', sort: 'Amount', select: i => Format.eur(i.Amount) },
          { name: 'Restbedrag', sort: 'Remaining_Amount', select: i => Format.eur(i.Remaining_Amount) },
          { name: 'Extern documentnr', sort: 'External_Document_No', select: i => i.External_Document_No },
        ]
      );
    },
    components: {
      'listview': Listview
    }
  };

  export default _comp;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/OpenPosten.vue